import type { UseMutationOptions } from "@tanstack/react-query";
import { useQueryClient } from "@tanstack/react-query";
import { apiRequest, type ApiError, useApiMutation } from "@/shared/api";
import type {
  KycSetupRequest,
  KycSetupResponse,
} from "../interfaces/kyc.interface";

const setupKycRequest = (payload: KycSetupRequest) => ({
  url: "/profile/setup",
  method: "post" as const,
  data: payload,
});

export const setupKyc = (payload: KycSetupRequest) =>
  apiRequest<KycSetupResponse>(setupKycRequest(payload));

export const useSetupKyc = (
  options?: UseMutationOptions<KycSetupResponse, ApiError, KycSetupRequest>
) => {
  const queryClient = useQueryClient();

  return useApiMutation<KycSetupResponse, KycSetupRequest>(setupKycRequest, {
    ...options,
    onSuccess: (data, variables, context, mutation) => {
      queryClient.invalidateQueries({ queryKey: ["profile"] });
      options?.onSuccess?.(data, variables, context, mutation);
    },
  });
};
